

















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { NewsEntry } from '@/models/home';

@Component
export default class HomeNewsCard extends Vue {

    @Prop(Object) public newsEntry: NewsEntry;
    @Prop(Boolean) public inLoadingState: boolean;

}
